// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"dashboard-app_dashboardContainer__juZ6V","mainContent":"dashboard-app_mainContent__O0Lqo"};